module.exports = __webpack_public_path__ + "assets/fonts/opensans-bold_76cc6be.ttf";